import { Entity } from '@api';
import { ScheduleDemoBanner } from '@terminal/views/insight-feed/components/schedule-demo-banner/ScheduleDemoBanner';
import { EarningsCatalystController } from '@terminal/widgets/catalyst-insights-drawer/catalyst-widget/EarningsCatalystController';
import { UpgradeToUnlock } from '@terminal/widgets/overview/components/upgrade-to-unlock/UpgradeToUnlock';
import React from 'react';
import { CatalystController } from '../catalyst-insights-drawer/catalyst-widget/CatalystController';
import { ScenarioInsightWidget } from '../insight-widget/components/insight-drawer/components/insights-drawer-content/ScenarioInsightWidget';
import { ActiveFlow } from './InsightDrawerShell';
import styles from './InsightDrawerShell.module.scss';

export const renderDrawerChildren = ({
  activeFlow,
  insightId,
  isBasicOrLightUser,
  contentWrapperRef,
  expandCitations,
  entity,
  navigateToKGInsight,
}: {
  activeFlow?: ActiveFlow;
  insightId: string;
  isBasicOrLightUser: boolean;
  contentWrapperRef: React.RefObject<HTMLDivElement | null>;
  expandCitations: boolean;
  entity?: Entity;
  navigateToKGInsight: () => void;
}) => {
  if (activeFlow === 'insights' && insightId) {
    return (
      <ScenarioInsightWidget
        insightId={insightId}
        contentWrapperRef={contentWrapperRef}
      />
    );
  }

  if (activeFlow === 'earnings' && !isBasicOrLightUser) {
    return (
      <div ref={contentWrapperRef} className={styles.shellContentWrapper}>
        <EarningsCatalystController
          navigateToKGInsight={navigateToKGInsight}
          expandCitations={expandCitations}
          entity={entity}
        />
      </div>
    );
  }

  if (activeFlow === 'catalyst' && insightId && !isBasicOrLightUser) {
    return (
      <div ref={contentWrapperRef} className={styles.shellContentWrapper}>
        <CatalystController
          navigateToKGInsight={navigateToKGInsight}
          expandCitations={expandCitations}
        />
        <ScheduleDemoBanner />
      </div>
    );
  }

  return <UpgradeToUnlock />;
};
